import { createFileRoute } from '@tanstack/react-router';

import { PersonalHub } from '../../features/personal/PersonalHub';

/** `/personal` = «شخصي» (خطة القسم الشخصي ش1). المسار رقيق والتركيب في الميزة. */
export const Route = createFileRoute('/personal/')({ component: PersonalHub });
